export const PATH = {
  HOME: "/",
  LOGIN: "/login",
  // REGISTER: "/register",
  FORGOT: "/forgot",
  RESET: "/reset-password",
  MY_PROFILE: "/my-profile",
}
